import { type RumInitConfiguration } from '@datadog/browser-rum';

import { shouldExcludeFromPerformanceReporting } from '@/modules/observability/shouldExcludeFromPerformanceReporting';

type DatadogRumSampleRateConfig = Pick<
  RumInitConfiguration,
  'sessionSampleRate' | 'sessionReplaySampleRate'
>;

export function getDatadogRumSampleRate(
  environment: string
): DatadogRumSampleRateConfig {
  const isExcluded = shouldExcludeFromPerformanceReporting(navigator.userAgent);

  switch (environment) {
    case 'production':
      /**
       * @TODO TN 16/1/24 - Incrementally ramp down sample rate
       * as traffic to new application increases
       */
      return {
        sessionSampleRate: isExcluded ? 0 : 10,
        sessionReplaySampleRate: 10,
      };
    case 'staging':
      return {
        sessionSampleRate: isExcluded ? 0 : 100,
        sessionReplaySampleRate: 0,
      };
    default:
      return {
        sessionSampleRate: 0,
        sessionReplaySampleRate: 0,
      };
  }
}
